export const CS_LANGUAGE = 'cs';
export const SK_LANGUAGE = 'sk';
